/* import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import {
  createAnalysisFolderPath,
  uploadSamplesheet,
  buildCommandString,
} from "../nfcore/coreUtils";
import API_BASE from "../config";

const nfcoreLauncher = () => {
  const { state } = useLocation();
  const {
    pipelineId,
    pipelineName,
    sampleSheet,
    selectedParams,
    files,
    cognitoUserId,
  } = state || {};

  const [analysisFolder, setAnalysisFolder] = useState("");
  const [fileMetadata, setFileMetadata] = useState([]);
  const [commandString, setCommandString] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");

  // Create analysis folder path
  useEffect(() => {
    if (pipelineName && cognitoUserId) {
      const folder = createAnalysisFolderPath(pipelineName, cognitoUserId);
      setAnalysisFolder(folder);
    }
  }, [pipelineName, cognitoUserId]);

  // Upload samplesheet.csv
  useEffect(() => {
    const upload = async () => {
      if (!analysisFolder || !sampleSheet) return;
      const result = await uploadSamplesheet(sampleSheet, analysisFolder);
      setUploadStatus(result.success ? "Samplesheet uploaded." : "Upload failed.");
    };
    upload();
  }, [analysisFolder, sampleSheet]);

  // Fetch metadata for selected files
  useEffect(() => {
    const fetchMetadata = async () => {
      const ids = files?.selectedFileIds || [];
      const paramFileIds = Object.values(files?.paramFileSelections || []);
      const allIds = Array.from(new Set([...ids, ...paramFileIds]));

      const metadata = [];
      for (const id of allIds) {
        try {
          const res = await axios.get(`${API_BASE}/user-files/${id}`);
          metadata.push(res.data.file);
        } catch (err) {
          console.warn(`Failed to fetch metadata for file ${id}`);
        }
      }
      setFileMetadata(metadata);
    };
    fetchMetadata();
  }, [files]);

  // Build command string
  useEffect(() => {
    const build = async () => {
      const command = await buildCommandString({
        pipelineId,
        selectedParams,
        paramFileSelections: files?.paramFileSelections,
        fileMetadata,
      });
      setCommandString(command);
    };
    build();
  }, [pipelineId, selectedParams, files, fileMetadata]);

  if (!state) {
    return <div style={{ padding: "30px" }}>No pipeline launch data found.</div>;
  }

  return (
    <div style={{ padding: "30px" }}>
      <h1>Pipeline Launch Summary</h1>

      <section style={{ marginBottom: "20px" }}>
        <h2>Analysis Folder</h2>
        <p>{analysisFolder}</p>
        <p>{uploadStatus}</p>
      </section>

      <section style={{ marginBottom: "20px" }}>
        <h2>Samplesheet</h2>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {Object.keys(sampleSheet?.[0] || {}).map((col) => (
                <th key={col} style={{ border: "1px solid #ccc", padding: "8px" }}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sampleSheet?.map((row, idx) => (
              <tr key={idx}>
                {Object.values(row).map((val, i) => (
                  <td key={i} style={{ border: "1px solid #eee", padding: "8px" }}>{val}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section style={{ marginBottom: "20px" }}>
        <h2>Selected Data Files</h2>
        <ul>
          {fileMetadata.map((file) => (
            <li key={file.id}>{file.filename}</li>
          ))}
        </ul>
      </section>

      <section style={{ marginBottom: "20px" }}>
        <h2>Parameters with File Inputs</h2>
        <ul>
          {Object.entries(files?.paramFileSelections || {}).map(([param, fileId]) => {
            const file = fileMetadata.find((f) => f.id === fileId);
            return <li key={param}>{param}: {file?.filename || "Unknown file"}</li>;
          })}
        </ul>
      </section>

      <section style={{ marginBottom: "20px" }}>
        <h2>Command String</h2>
        <pre style={{ background: "#f4f4f4", padding: "10px", borderRadius: "4px" }}>
          {commandString}
        </pre>
      </section>
    </div>
  );
};

export default nfcoreLauncher; */